import React from "react";
import cn from "classnames";
import styles from "../../../components/Card/Card.module.sass";
import Player from "../../../components/Player";
import config from '../../../config'

const imageSize = {h: 303, w: 256}

const Preview = ({className, tokenData}) => {
    tokenData.type = 'image'
    tokenData.local_uri = tokenData?.preview ? tokenData.preview : '/images/content/card-pic-6.jpg'

    return (
        <div className={cn(styles.card, className)}>
            <div className={styles.preview}>
                <div className={styles.id_section}>
                    <div className={cn(styles.id)}>
                        ID:
                        <span>000</span>
                    </div>
                </div>
                <Player item={tokenData} sizes={imageSize}/>
            </div>
            <div className={styles.link}>
                <div className={styles.body}>
                    <div className={styles.line}>
                        <div className={styles.title}>{tokenData.valueName ?? 'Black Golden Tiger'}</div>
                        <div className={styles.price}>{tokenData.valuePrice ?? '2.45'}&nbsp;{config.symbolName}</div>
                    </div>
                    <div className={styles.line}>
                        <div className={styles.users}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Preview;
